import image1 from "../images/event_image/2025/1.JPG";
import image2 from "../images/event_image/2025/2.JPG";
import image3 from "../images/event_image/2025/3.JPG";
import image4 from "../images/event_image/2025/4.JPG";
import image5 from "../images/event_image/2025/5.JPG";
import image6 from "../images/event_image/2025/6.JPG";
import image7 from "../images/event_image/2025/7.JPG";
import image8 from "../images/event_image/2025/8.JPG";
import image9 from "../images/event_image/2025/9.JPG";
import image10 from "../images/event_image/2025/10.JPG";
import image11 from "../images/event_image/2025/11.JPG";
import image12 from "../images/event_image/2025/12.JPG";
import image13 from "../images/event_image/2025/13.JPG";
import image14 from "../images/event_image/2025/14.JPG";
import image15 from "../images/event_image/2025/15.JPG";
import image16 from "../images/event_image/2025/16.JPG";
import image17 from "../images/event_image/2025/17.JPG";
import image18 from "../images/event_image/2025/18.JPG";
import image19 from "../images/event_image/2025/19.JPG";
import image20 from "../images/event_image/2025/20.JPG";
import image21 from "../images/event_image/2025/21.JPG";
import image22 from "../images/event_image/2025/22.JPG";
import image23 from "../images/event_image/2025/23.JPG";
import image24 from "../images/event_image/2025/24.JPG";
import image25 from "../images/event_image/2025/25.JPG";
import image28 from "../images/event_image/2025/28.JPG";
import image30 from "../images/event_image/2025/30.JPG";


import image26 from "../images/event_image/2025/1.jpeg";
import image27 from "../images/event_image/2025/2.jpeg";
import image29 from "../images/event_image/2025/3.jpeg";
import image31 from "../images/event_image/2025/4.jpeg";
import image32 from "../images/event_image/2025/5.jpeg";
import image33 from "../images/event_image/2025/6.jpeg";
import image34 from "../images/event_image/2025/7.jpeg";
import image35 from "../images/event_image/2025/8.jpeg";
import image36 from "../images/event_image/2025/9.jpeg";
import image37 from "../images/event_image/2025/10.jpeg";
import image38 from "../images/event_image/2025/11.jpeg";
import image39 from "../images/event_image/2025/12.jpeg";
import image40 from "../images/event_image/2025/13.jpeg";
import image41 from "../images/event_image/2025/14.jpeg";
import image42 from "../images/event_image/2025/17.jpeg";
import image43 from "../images/event_image/2025/18.jpeg";
import image44 from "../images/event_image/2025/19.jpeg";
import image45 from "../images/event_image/2025/21.jpeg";
import image46 from "../images/event_image/2025/25.jpeg";
import image47 from "../images/event_image/2025/26.jpeg";
import image48 from "../images/event_image/2025/28.jpeg";
import image49 from "../images/event_image/2025/29.jpeg";
import image50 from "../images/event_image/2025/31.jpeg";
import image51 from "../images/event_image/2025/32.jpeg";
import image52 from "../images/event_image/2025/33.jpeg";
import image53 from "../images/event_image/2025/35.jpeg";
import image54 from "../images/event_image/2025/37.jpeg";
import image55 from "../images/event_image/2025/38.jpeg";
import image56 from "../images/event_image/2025/39.jpeg";
import image57 from "../images/event_image/2025/40.jpeg";
import image58 from "../images/event_image/2025/41.jpeg";
import image59 from "../images/event_image/2025/42.jpeg";
import image60 from "../images/event_image/2025/43.jpeg";
import image61 from "../images/event_image/2025/44.jpeg";
import image62 from "../images/event_image/2025/45.jpeg";
import image63 from "../images/event_image/2025/46.jpeg";
import image64 from "../images/event_image/2025/47.jpeg";
import image65 from "../images/event_image/2025/48.jpeg";
import image66 from "../images/event_image/2025/49.jpeg";
import image67 from "../images/event_image/2025/50.jpeg";

const images = [
  {
    key: 1,
    image: image1,
  },
  {
    key: 2,
    image: image2,
  },
  {
    key: 3,
    image: image3,
  },
  {
    key: 4,
    image: image4,
  },
  {
    key: 5,
    image: image5,
  },
  {
    key: 6,
    image: image6,
  },
  {
    key: 7,
    image: image7,
  },
  {
    key: 8,
    image: image8,
  },
  {
    key: 9,
    image: image9,
  },
  {
    key: 10,
    image: image10,
  },
  {
    key: 11,
    image: image11,
  },
  {
    key: 12,
    image: image12,
  },
  {
    key: 13,
    image: image13,
  },
  {
    key: 14,
    image: image14,
  },
  {
    key: 15,
    image: image15,
  },
  {
    key: 16,
    image: image16,
  },
  {
    key: 17,
    image: image17,
  },
  {
    key: 18,
    image: image18,
  },
  {
    key: 19,
    image: image19,
  },
  {
    key: 20,
    image: image20,
  },
  {
    key: 21,
    image: image21,
  },
  {
    key: 22,
    image: image22,
  },
  {
    key: 23,
    image: image23,
  },
  {
    key: 24,
    image: image24,
  },
  {
    key: 25,
    image: image25,
  },
  {
    key: 26,
    image: image26,
  },
  {
    key: 27,
    image: image27,
  },
  {
    key: 28,
    image: image28,
  },
  {
    key: 29,
    image: image29,
  },
  {
    key: 30,
    image: image30,
  },
  {
    key: 31,
    image: image31,
  },
  {
    key: 32,
    image: image32,
  },
  {
    key: 33,
    image: image33,
  },
  {
    key: 34,
    image: image34,
  },
  {
    key: 35,
    image: image35,
  },
  {
    key: 36,
    image: image36,
  },
  {
    key: 37,
    image: image37,
  },
  {
    key: 38,
    image: image38,
  },
  {
    key: 39,
    image: image39,
  },
  {
    key: 40,
    image: image40,
  },
  {
    key: 41,
    image: image41,
  },
  {
    key: 42,
    image: image42,
  },
  {
    key: 43,
    image: image43,
  },
  {
    key: 44,
    image: image44,
  },
  {
    key: 45,
    image: image45,
  },
  {
    key: 46,
    image: image46,
  },
  {
    key: 47,
    image: image47,
  },
  {
    key: 48,
    image: image48,
  },
  {
    key: 49,
    image: image49,
  },
  {
    key: 50,
    image: image50,
  },
  {
    key: 51,
    image: image51,
  },
  {
    key: 52,
    image: image52,
  },
  {
    key: 53,
    image: image53,
  },
  {
    key: 54,
    image: image54,
  },
  {
    key: 55,
    image: image55,
  },
  {
    key: 56,
    image: image56,
  },
  {
    key: 57,
    image: image57,
  },
  {
    key: 58,
    image: image58,
  },
  {
    key: 59,
    image: image59,
  },
  {
    key: 60,
    image: image60,
  },
  {
    key: 61,
    image: image61,
  },
  {
    key: 62,
    image: image62,
  },
  {
    key: 63,
    image: image63,
  },
  {
    key: 64,
    image: image64,
  },
  {
    key: 65,
    image: image65,
  },
  {
    key: 66,
    image: image66,
  },
  {
    key: 67,
    image: image67,
  },
];

export default images;
